import { createSlice } from "@reduxjs/toolkit";

type VehiclesSyncState = Record<string, boolean>;

const initialState: VehiclesSyncState = {};

export const Slice = createSlice({
  name: "vehiclesSyncState",
  initialState,
  reducers: {
    resetVehicleSyncState: () => initialState,
    updateVehiclesSyncState: (state, action) => {
      state[action.payload.vehicle_id] = action.payload.isSynchronizing;
      return state;
    },
    setVehiclesSyncStateWebsocket: (state, action) => {
      action.payload.forEach((vehicleWebsocketData: VehicleState) => {
        state[vehicleWebsocketData.vehicle_id] = false;
      });
      return state;
    },
    setVehiclesSyncStateHTTP: (state, action) => {
      if (Object.keys(state).length === 0) {
        state = action.payload.reduce(
          (acc: Record<string, boolean>, vehicle: Vehicle) => {
            acc[vehicle.id] = false;
            return acc;
          },
          {}
        );
      }
      return state;
    },
  },
});

export default Slice;
